import _extends from "@babel/runtime/helpers/extends";
import { jsx as _jsx } from "react/jsx-runtime";

var VSCTerminalPowershell = props => /*#__PURE__*/_jsx("svg", _extends({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  height: "1em",
  width: "1em"
}, props, {
  children: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m2.5 1.007 12.999.17.43.501-1.82 12.872-.57.489-13-.17-.43-.502L1.93 1.495l.57-.488zM1.18 13.885l11.998.157 1.68-11.882L2.86 2.003 1.18 13.885zm5.791-3.49-.14.991 5 .066.14-.99-5-.066zm1.71-2.457-3.663-2.93-.692.796 2.636 2.112L3.739 9.95l.465.812L8.68 7.938z"
  })
}));

export { VSCTerminalPowershell };